import React from 'react'
import { makeStyles } from '@material-ui/core'
import Link from '@material-ui/core/Link'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  footerLink: {
    color: theme.palette.footer.main,
    '&:hover': {
      color: theme.palette.footer.hover,
      textDecoration: 'none',
    },
  },
  text: {
    display: 'inline-flex',
  },
}))

const FooterLink = ({ text, name, link }) => {
  const classes = useStyles()
  const intl = useIntl()

  return (
    <Link className={classes.footerLink} href={link} aria-label={name}>
      {intl.formatMessage({ id: text })}
    </Link>
  )
}

FooterLink.propTypes = {
  text: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
}

export default FooterLink
